import { Button } from "primereact/button";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectAttachmentsByQuestion } from "../../store/selectors/attachmentSelectors";
import { setViewingAttachments } from "../../store/slices/attachmentSlice";
import { useCallback } from "react";
import { Badge } from "primereact/badge";

interface Props {
    questionId: string;
}

export const PhotoButton = ({ questionId }: Props) => {
    const dispatch = useAppDispatch();
    const attachmentsByQuestion = useAppSelector(selectAttachmentsByQuestion);

    const attachments = attachmentsByQuestion[questionId] || [];
    const count = attachments.length;

    const handleClick = useCallback(() => {
        if (count > 0) {
            dispatch(setViewingAttachments(attachments));
        }
    }, [dispatch, attachments, count]);

    if (count === 0) {
        return <span className="text-color-secondary">-</span>;
    }

    return (
        <Button
            icon="pi pi-images"
            severity="secondary"
            text
            size="small"
            onClick={handleClick}
            className="p-overlay-badge"
            tooltip={`View ${count} photo${count !== 1 ? 's' : ''}`}
            tooltipOptions={{ position: "top" }}
        >
            <Badge value={count} severity="info" />
        </Button>
    );
};
